import React, { useState, useEffect } from 'react';
import { Button, Card, CardHeader, Table, Container, Row, Col, Form, FormGroup, InputGroupAddon, InputGroupText, Input, InputGroup, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Modal, ModalHeader, ModalBody, Badge, Label, UncontrolledTooltip } from "reactstrap";
import { Link } from 'react-router-dom';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {api} from '../../../../api';
import Cookies from 'js-cookie';

const Requestresource3 = () => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [projectDropdownOpen, setProjectDropdownOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [dataToShow, setDataToShow] = useState([]);
    const [entriesToShow, setEntriesToShow] = useState(10);
    
    const [material, setMaterial] = useState([]);
    const [dropdownStates, setDropdownStates] = useState([]);
    const [filtered, setFiltered] = useState([]);
    const [forceUpdate, setForceUpdate] = useState(0);
    const [isRefreshing, setIsRefreshing] = useState(false);


    const emp_id = Cookies.get('emp_id');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const company_id = Cookies.get('company_id');
                const emp_id = Cookies.get('emp_id');
                const response2 = await api.get(`requestresourse.php?hr='hr'&company_id=${company_id}&emp_id=${emp_id}`);
                setMaterial(response2.data);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchData();
    }, []);

    // Update filtered data when material changes
    useEffect(() => {
        console.log('Material changed, updating filtered data...');
        if (Array.isArray(material)) {
            const filteredData = material.filter(item => {
                const role = item.role ? item.role.toLowerCase() : "";
                const quantity = item.quantity ? String(item.quantity).toLowerCase() : "";
                const description = item.description ? item.description.replace(/<\/?[^>]+(>|$)/g, '').toLowerCase() : "";
                const status = item.status ? item.status.toLowerCase() : "";
                const hr_status = item.hr_status ? item.hr_status.toLowerCase() : "";
                const search = searchQuery.toLowerCase();
                return (
                    role.includes(search) ||
                    quantity.includes(search) ||
                    description.includes(search) ||
                    status.includes(search) ||
                    hr_status.includes(search)
                );
            });
            setFiltered(filteredData);
            console.log('Filtered data updated:', filteredData);
        }
    }, [material, searchQuery]);

    // const [selectedproject, setselectedproject] = useState();

    const handleProjectSelection = async (p_id, p_name) => {

        setselectedproject(p_name);

        try {
            const company_id = Cookies.get('company_id');
            const response = await api.get(`requestresourse.php?pid=${p_id}&company_id=${company_id}`);
            console.log('API Response:', response.data);
            setMaterial(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleDropdownToggle = (index) => {
        setDropdownStates(prevState => {
            const newState = [...prevState];
            newState[index] = !newState[index];
            return newState;
        });
    };

    const statusOptions = [
        { value: "Approved", label: "Accept" },
        { value: "Rejected", label: "Reject" }
    ];

    const [modalEmployee, setModalEmployee] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedproject, setselectedproject] = useState();
    const [modal, setModal] = useState(false); // State to control modal visibility
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');

    const toggleModalView = () => {
        setModalOpen(!modalOpen);
    };

    const toggleModal = () => {
        setModal(!modal);
    };

    const [report, setreport] = useState({
        hr_id : emp_id,
        r_id : '',
        status : '',
        report : ''
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setreport((prevState) => ({
        ...prevState,
        [name]: value,
        }));

        console.log(report)
    };

    const handleItemClick = (id) => {
        // setSelectedId(id);
        setreport((prevState) => ({
          ...prevState,
          r_id : id,
        }));
        toggleModal();
      };

    const refreshData = async () => {
        console.log('Refreshing data...');
        setIsRefreshing(true);
        try {
            const company_id = Cookies.get('company_id');
            const emp_id = Cookies.get('emp_id');
            console.log('Company ID:', company_id, 'Emp ID:', emp_id);
            const response2 = await api.get(`requestresourse.php?hr='hr'&company_id=${company_id}&emp_id=${emp_id}`);
            console.log('Refresh response:', response2.data);
            setMaterial(response2.data);
            console.log('Material state updated');
            
            // Force a re-render by updating a timestamp
            setForceUpdate(Date.now());
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setIsRefreshing(false);
        }
    };

    const handleStatusAction = async (e) => {
        e.preventDefault();
        if (!report.status || !report.report.trim()) {
            alert('Please select a status and enter a description.');
            return;
        }
        try {
            const company_id = Cookies.get('company_id');
            if (!company_id) {
                alert('Company ID not found. Please log in again.');
                return;
            }
            const formDataToSend = {
                ...report,
                company_id: company_id
            };
            const response = await api.post('resourceAction.php', formDataToSend);
            console.log(response.data);
            if (response.data.status === 'success') {
                console.log('=== SUCCESS RESPONSE RECEIVED ===');
                setSuccessMessage('Status updated successfully!');
                console.log('Success message set, now setting showSuccessAlert to true');
                setShowSuccessAlert(true);
                console.log('showSuccessAlert set to true, current state:', showSuccessAlert);
                toggleModal(); // Close the action modal
                console.log('Action modal closed');
                
                // Force the success alert to show
                setTimeout(() => {
                    console.log('Checking showSuccessAlert state after timeout:', showSuccessAlert);
                    if (showSuccessAlert) {
                        console.log('Success alert should be visible');
                    } else {
                        console.log('Success alert state is false, forcing it to true');
                        setShowSuccessAlert(true);
                    }
                }, 100);
            } else {
                alert(response.data.message || 'Failed to update status');
            }
        } catch (error) {
            console.error('Error updating status:', error);
            alert('Error updating status. Please try again.');
        }
    };

   

    return (
        <>
            <div className="header bg-gradient-info py-7 py-lg-8">
                <Container fluid>
                                       <Row className="align-items-center mb-4">

  {/* Mobile & Tablet View: Heading at top center */}
  <Col xs="12" className="d-lg-none text-center mb-3">
    <h1 className="mb-0 font-bold">Resource Details</h1>
  </Col>

  {/* Desktop View: Heading at start of row */}
  <Col lg="6" className="d-none d-lg-block text-left">
    <h1 className="mb-0 font-bold">Resource Details</h1>
  </Col>

  {/* Debug info */}
  

  {/* Mobile & Tablet View: Search Bar at bottom */}
  <Col xs="12" className="d-lg-none d-flex justify-content-center">
    <Form className="navbar-search px-2 w-full" style={{ maxWidth: '300px' }}>
      <FormGroup className="mb-0 w-full">
        <InputGroup className="input-group-alternative align-items-center h-[40px]">
          <InputGroupAddon addonType="prepend">
            <InputGroupText className="border-right-0 h-[38px]">
              <i className="fas fa-search text-black" />
              <Input
                placeholder="Search Resources"
                type="text"
                className="border-left-0 ml-2 h-[38px]"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </InputGroupText>
          </InputGroupAddon>
        </InputGroup>
      </FormGroup>
    </Form>
  </Col>

  {/* Desktop View: Search Bar at end of row */}
  <Col lg="6" className="d-none d-lg-flex justify-content-end">
    <Form className="navbar-search px-2 w-full" style={{ maxWidth: '300px' }}>
      <FormGroup className="mb-0 w-full">
        <InputGroup className="input-group-alternative align-items-center h-[40px]">
          <InputGroupAddon addonType="prepend">
            <InputGroupText className="border-right-0 h-[38px]">
              <i className="fas fa-search text-black" />
              <Input
                placeholder="Search Resources "
                type="text"
                className="border-left-0 ml-2 h-[38px]"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </InputGroupText>
          </InputGroupAddon>
        </InputGroup>
      </FormGroup>
    </Form>
  </Col>
</Row>
                    <marquee behavior="scroll" direction="right"  style={{height:'58px'}}>
          {/* <img src={require("../../assets/img/brand//240_F_364017781_DR0bENAGus0GPESus7E2w4JaT7wzIZ1M-removebg-preview.png")} style={{ height: '100px' ,marginbottom:'-17px' }} alt="Delivery Truck" /> */}
          <img src={require("../../../project-management/assets/img/brand/delivery-truck-1--unscreen.gif")} style={{ height: '80px' ,marginbottom:'-17px' }} alt="Delivery Truck" />
          Resource Delivery
            </marquee>
                    <Row className="">
                        <Col className="mb-5 mb-xl-0" xl="12">
                            <Card className="" style={{boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',backgroundColor: '#fff',borderRadius: '15px'}}>
                                <CardHeader className="border-0">
                                    <Row className="align-items-center">
                                        <div className="col">
                                            <h3 className="mb-0">
                                                Resource List 
                                                {isRefreshing && <span className="ml-2 text-info">🔄 Refreshing...</span>}
                                            </h3>
                                        </div>
                                        <div className="col text-right">
                                            <Button 
                                                size="sm" 
                                                color="info" 
                                                onClick={refreshData}
                                                disabled={isRefreshing}
                                            >
                                                {isRefreshing ? 'Refreshing...' : '🔄 Refresh'}
                                            </Button>
                                        </div>
                                    </Row>
                                </CardHeader>
                                <Table className="align-items-center table-flush" responsive>
                                    <thead className="thead-light">
                                        <tr>
                                            <th scope="col">SL.No</th>
                                            <th scope="col">Resource Type</th>
                                            <th scope="col">Quantity</th>
                                            <th scope="col">Description</th>
                                            <th scope="col">Status</th>
                                            <th scope="col">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {filtered && filtered.length > 0 ? (
                                    filtered.map((material, index) => (
                                        <tr key={index}>
                                            <td>{++index}</td>
                                        <td>{material.role}</td>
                                        <td>{material.quantity}</td>
                                        <td>{material.description ? material.description.replace(/<\/?[^>]+(>|$)/g, '') : 'N/A'}</td>
                                        <td>
                                        {
                                            material.hr_status && material.hr_status.trim() !== ''
                                              ? (
                                                  material.hr_status === "pending" ? (
                                                    <Badge style={{ backgroundColor: 'yellow', color: 'black' }}>{material.hr_status}</Badge>
                                                  ) : material.hr_status === "Rejected" ? (
                                                    <Badge style={{ backgroundColor: 'red', color: 'black' }}>{material.hr_status}</Badge>
                                                  ) : (
                                                    <Badge style={{ backgroundColor: 'green', color: 'white' }}>{material.hr_status}</Badge>
                                                  )
                                                )
                                              : <Badge style={{ backgroundColor: 'yellow', color: 'black' }}>pending</Badge>
                                        }


                                        </td>
                                        <td>
                                            <button
                                                className='btn btn-success'
                                                style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}}
                                                onClick={() => { setModalEmployee(material); toggleModalView(); }}
                                                id={`view-tooltip-${material.r_id}`}
                                            >
                                                <i className="fa-solid fa-eye" style={{fontSize:'22px'}} ></i>
                                            </button>
                                            <UncontrolledTooltip delay={0} target={`view-tooltip-${material.r_id}`}>
                                                View Resource Details
                                            </UncontrolledTooltip>
                                            <button className='btn btn-success' style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}} onClick={() => handleItemClick(material.r_id) }>Set Action</button>
                                        </td>
                                        </tr>
                                    ))
                                    ) : (
                                    <tr>
                                        <td colSpan="5" style={{ textAlign: 'center' }}>No details available, Project not yet started</td>
                                    </tr>
                                    )}

                                    </tbody>
                                </Table>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

            <Modal isOpen={modal} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}><h2 style={{fontWeight:'bolder'}}>Status Action</h2></ModalHeader>
                <ModalBody>
                    {/* Your form elements go here */}
                    <Form onSubmit={handleStatusAction} >
                        <FormGroup>
                            <Label for="exampleSelect">Select</Label>
                            <Input
                                className="form-control-alternative"
                                id="input-status"
                                type="select"
                                name="status"
                                onChange={handleInputChange}
                                required
                            >
                                <option value="">Select Status</option>
                                {statusOptions.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                                ))}
                            </Input>
                        </FormGroup>
                        <FormGroup>
                            <Label for="exampleText">Description</Label>
                            <Input type="textarea" name="report" id="exampleText" onChange={handleInputChange} required />
                        </FormGroup>
                        <Row>
                            <Col lg='12' style={{ textAlign: 'center' }}>
                                <Button style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}} type="submit">Submit</Button>
                            </Col>
                            </Row>
                        {/* Add more form fields as needed */}
                    </Form>
                </ModalBody>
            </Modal>

            {modalEmployee && modalEmployee && (
              <Modal isOpen={modalOpen} toggle={toggleModalView}>
                <ModalHeader toggle={toggleModalView}>Resource View</ModalHeader>
                <ModalBody>
                  {modalEmployee && (
                    <div style={{ maxWidth: '400px', margin: '0 auto' }}>
                      <table style={{ width: '100%' }}>
                        <tbody>
                          <tr>
                            <td style={{ fontWeight: 'bold', padding: '8px 0', textAlign: 'left', width: '45%' }}>Resource Type</td>
                            <td style={{ padding: '8px 0', textAlign: 'left' }}>{modalEmployee.role}</td>
                          </tr>
                          <tr>
                            <td style={{ fontWeight: 'bold', padding: '8px 0', textAlign: 'left' }}>Quantity</td>
                            <td style={{ padding: '8px 0', textAlign: 'left' }}>{modalEmployee.quantity}</td>
                          </tr>
                          <tr>
                            <td style={{ fontWeight: 'bold', padding: '8px 0', textAlign: 'left' }}>Description</td>
                            <td style={{ padding: '8px 0', textAlign: 'left' }}>{modalEmployee.description ? modalEmployee.description.replace(/<\/?[^>]+(>|$)/g, '') : 'N/A'}</td>
                          </tr>
                          <tr>
                            <td style={{ fontWeight: 'bold', padding: '8px 0', textAlign: 'left' }}>General Manager</td>
                            <td style={{ padding: '8px 0', textAlign: 'left' }}>{modalEmployee.status}</td>
                          </tr>
                          <tr>
                            <td style={{ fontWeight: 'bold', padding: '8px 0', textAlign: 'left' }}>General Action</td>
                            <td style={{ padding: '8px 0', textAlign: 'left' }}>{modalEmployee.gm_report}</td>
                          </tr>
                          <tr>
                            <td style={{ fontWeight: 'bold', padding: '8px 0', textAlign: 'left' }}>HR</td>
                            <td style={{ padding: '8px 0', textAlign: 'left' }}>{modalEmployee.hr_status}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )}
                </ModalBody>
              </Modal>
            )}
            <Modal isOpen={showSuccessAlert} toggle={() => setShowSuccessAlert(false)}>
              <ModalHeader toggle={() => setShowSuccessAlert(false)}>
                <h4 style={{ color: '#28a745', margin: 0 }}>Success!</h4>
              </ModalHeader>
              <ModalBody className="text-center">
                <div style={{ fontSize: '48px', color: '#d86f89', marginBottom: '20px' }}>✓</div>
                <p style={{ color: '#333', fontSize: '16px', marginBottom: '20px' }}>{successMessage}</p>
                
                {/* Test button to see if modal is working */}
                <button 
                  type="button" 
                  className="btn btn-secondary mb-2 me-2"
                  onClick={() => alert('Test button works!')}
                >
                  Test Button
                </button>
                
                <Button
                  style={{
                    backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'white',
                    padding: '10px 25px', borderRadius: '25px'
                  }}
                  onClick={async () => {
                    alert('OK button clicked!'); // Test if click is working
                    console.log('=== OK BUTTON CLICKED ===');
                    console.log('Current material state:', material);
                    console.log('Current filtered state:', filtered);
                    setShowSuccessAlert(false);
                    console.log('Success alert closed, now calling refreshData...');
                    await refreshData(); // Call the refresh function
                    console.log('=== REFRESH COMPLETED ===');
                  }}
                >OK</Button>
              </ModalBody>
            </Modal>
        </>
    );
};

export default Requestresource3;
